module.exports = __webpack_public_path__ + "img/hero-main.4aa7a728.png";